<template>
  <div>
    <div v-if="selectedComp && !loading" class="row ag-computer p-4">
      <div class="col-md-6">
        <div class="d-flex justify-content-between mb-4">
          <div class="w-50">
            <h5>
              <ag-truncate
                :text="selectedComp.WindowsComputerName"
                :options="{ position: 'middle', first: 8, last: 8 }"
              ></ag-truncate>
            </h5>
            <h6>Endpoint Host Name</h6>
          </div>
          <div class="w-50">
            <h5>
              <ag-truncate
                :text="selectedComp.MachineDomainWorkgroup"
                :options="{ position: 'middle', first: 13, last: 13 }"
              ></ag-truncate>
            </h5>
            <h6>{{ $t("domain") }}</h6>
          </div>
        </div>

        <div class="d-flex justify-content-between mb-4">
          <div class="w-50">
            <h5>
              {{
                selectedComp.companySiteGroupInfo
                  ? selectedComp.companySiteGroupInfo.siteName
                  : ""
              }}
            </h5>
            <h6>{{ $t("sitename") }}</h6>
          </div>
          <div class="w-50">
            <h5>
              <ag-truncate
                :text="selectedComp.companySiteGroupInfo.groupName"
                v-if="selectedComp.companySiteGroupInfo"
                :options="{ position: 'middle', first: 13, last: 13 }"
              ></ag-truncate>
            </h5>
            <h6>{{ $t("groupname") }}</h6>
          </div>
        </div>
        <div class="d-flex justify-content-between mb-4">
          <div class="w-50">
            <h5>{{ selectedComp.PolicyFileVersion }}</h5>
            <h6>{{$t("policyversion")}}</h6>
          </div>
          <div class="w-50">
            <h5>
              {{ selectedComp.eventCount }}
            </h5>
            <h6>{{$t("eventcount")}}</h6>
          </div>
        </div>

        <div class="d-flex justify-content-between mb-4">
          <div class="w-50">
            <h5>{{ selectedComp.LastIPv4 }}</h5>
            <h6>{{$t("lastIpV4")}}</h6>
          </div>
          <div class="w-50">
            <h5>
              <ag-truncate
                :text="selectedComp.LastIPv6"
                :options="{ position: 'middle', first: 15, last: 15 }"
              ></ag-truncate>
            </h5>
            <h6>{{$t("lastIpV6")}}</h6>
          </div>
        </div>

        <div class="d-flex justify-content-between mb-4">
          <div class="w-50">
            <h5>{{ selectedComp.AgentVersion }}</h5>
            <h6>{{$t("agentversion")}}</h6>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row graphs">
          <div class="col-md-12 last-30-day-computer">
            <i class="ag-icon ag-icon_info mr-2"></i> {{$t("last30days")}}
          </div>
          <div class="col-md-6">
            <ag-charts
              style="height: 350px !important"
              :options="maliciousHashes"
            ></ag-charts>
          </div>
          <div class="col-md-6">
            <ag-charts
              style="height: 350px !important"
              :options="severityDistribution"
            ></ag-charts>
          </div>
        </div>
      </div>
    </div>
    <ag-loading v-if="loading" />
    <div v-if="!selectedComp && !loading" class="no-data-center">{{$t("noData")}}</div>
  </div>
</template>

<script>
import AgCharts from "@/components/ag-charts";
import { useStore } from "@/store";
import api from "@/store/axiosAgsc";
import AgLoading from "@/components/ag-loading/index.vue";
import AgTruncate from "@/components/ag-truncate/index.vue";

const store = useStore();
export default {
  name: "ag-computer",
  data() {
    return {
      selectedComp: {},
      loading: true,
      maliciousHashes: {
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "0",
          left: "center",
          textStyle: {
            fontSize: "11",
          },
        },
        series: [
          {
            name: "Numbers of found hashes",
            type: "pie",
            radius: ["54%", "60%"],
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: "center",
              backgroundColor: "#f8f8f8",
              padding: 10,
            },
            data: [],
          },
        ],
        color: ["#D15656", "#F2AE11", "#61A667"],
      },
      severityDistribution: {
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "0",
          left: "center",
          textStyle: {
            fontSize: "11",
          },
        },
        series: [
          {
            name: "Severity Distribution",
            type: "pie",
            radius: ["54%", "60%"],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: true,
              position: "center",
              backgroundColor: "#f8f8f8",
              padding: 10,
            },
            data: [],
          },
        ],
        color: ["#D15656", "#F2AE11", "#61A667"],
      },
    };
  },
  components: { AgCharts, AgLoading, AgTruncate },
  mounted() {
    setTimeout(() => {
      this.getList();
    }, 100);
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
  },
  watch: {
    selectedRow(newItem, oldItem) {
      setTimeout(() => {
        this.getList();
      }, 100);
    },
  },
  methods: {
    getList() {
      if (
        !this.selectedRow.computerGuid ||
        typeof this.selectedRow.computerGuid === "undefined"
      ) {
        return;
      }
      api
        .get(
          `Computer/GetComputerDetail?computerGuid=${this.selectedRow.computerGuid}&eventType=${this.selectedRow.eventType}&groupId=${this.selectedRow.groupGuid}`
        )
        .then((res) => {
          this.selectedComp = res.data.entityData;
          res.data.entityData.severityReport.forEach((item) => {
            this.severityDistribution.series[0].data.push({
              name: `Severity ${item.key}`,
              value: item.value,
            });
          });
          res.data.entityData.hashReport.forEach((item) => {
            this.maliciousHashes.series[0].data.push({
              name: item.key,
              value: item.value,
            });
          });

          if (
            !this.maliciousHashes.series[0].data.find(
              (i) => i.name == "Malicious"
            )
          ) {
            this.maliciousHashes.series[0].data.push({
              name: "Malicious",
              value: 0,
              itemStyle: { color: "#d15656" },
            });
          }

          if (
            !this.maliciousHashes.series[0].data.find(
              (i) => i.name == "Suspicious"
            )
          ) {
            this.maliciousHashes.series[0].data.push({
              name: "Suspicious",
              value: 0,
              itemStyle: { color: "#f2ae11" },
            });
          }
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-computer {
  h3 {
    color: #5e5e5e;
  }
  h6 {
    color: #9f9f9f;
  }
  .graphs {
    margin-top: -60px;
  }
  .last-30-day-computer {
    margin-bottom: -60px;
    margin-top: 60px;
    font-size: 14px;
    color: #d15656;
    display: flex;
    align-items: center;
    justify-content: end;
  }
}
</style>
